import type { IconSvgObject } from './types';

const PropertyAddIcon: IconSvgObject = [
  ["path", { d: "M3 7.5H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 16H12.5M6.5 16H7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.5 12H16.5M6.5 12H7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18.4943 15.5V21.5M21.5 18.4935L15.5 18.4935", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12.5 20.5L4.5 20.5C3.39543 20.5 2.5 19.6046 2.5 18.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H18.5C19.6046 2.5 20.5 3.39543 20.5 4.5V12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default PropertyAddIcon;
